// extracted by mini-css-extract-plugin
module.exports = {"payments":"payments_payments__3cq5n","payments__item":"payments_payments__item__9s1jF"};